import { createFormContext } from "@mantine/form";
import { StrictUndef } from "shared/api/httpClient";
import * as zx from "shared/utils/zod";
import { IngestRuleDetailsFragment, IngestRuleInfoInput } from "src/gql/graphql";
import { IngestRuleInfoInputSchema } from "src/gql/zod";
import { z } from "zod";

export const ingestRuleFormStateSchema = z.object({
    matchKey: zx.nonemptyString(),
    matchExpr: zx.nonemptyString(),
    destinationTemplateId: zx.coercedUUID().optional(),
});

export type IngestRuleFormState = z.infer<typeof ingestRuleFormStateSchema>;

export function createIngestRuleFormState(incoming: StrictUndef<IngestRuleDetailsFragment>): IngestRuleFormState {
    return ingestRuleFormStateSchema.parse({
        matchExpr: incoming.matchExpr ?? "",
        matchKey: incoming.matchKey ?? "",
        destinationTemplateId: incoming.destinationTemplate,
    });
}

export function ingestRuleFormStateToInfo(state: IngestRuleFormState): IngestRuleInfoInput {
    return IngestRuleInfoInputSchema().parse(state);
}

export const [IngestRuleFormProvider, useIngestRuleFormContext, useIngestRuleForm] = createFormContext<IngestRuleFormState>();
